import { templateApi } from "@/core/data/api";

export default async (data) => {
  return await templateApi.createTemplate(data);
};
